import { useForm } from "@/src/provider/Form/FormProvider";
import React from "react";
import { formValue } from "@/src/services/formServiceFunctions";
import ValidatorSelectField, { ValidatorSelectFieldProps } from "./ValidatorSelectField";
import { FormDataTypes } from "@/src/types/FormDataTypes";
import MenuItem from "@mui/material/MenuItem";
import { Checkbox, Typography } from "@mui/material";

type ValidatorMultiSelectFieldWithCheckboxesProps = Omit<ValidatorSelectFieldProps<string[]>, "multiple" | "children"> & {
  options: Array<{ value: string; label: string }>;
};
export default function ValidatorMultiSelectFieldWithCheckboxes({ options, name, ...rest }: ValidatorMultiSelectFieldWithCheckboxesProps) {
  const { values }: FormDataTypes = useForm();

  return (
    <ValidatorSelectField
      name={name}
      multiple
      {...rest}
      renderValue={(selected: string[]) => {
        return selected.map((value) => options.find((option) => option.value === value)?.label).join(", ");
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          <Checkbox checked={formValue(values, name).includes(option.value)} />
          <Typography sx={{ whiteSpace: "normal" }}>{option.label}</Typography>
        </MenuItem>
      ))}
    </ValidatorSelectField>
  );
}
